import styled from "styled-components"

const StyledStrategyMain = styled.section`
  /* background-color: rgba(0, 0, 0, 0.45);  */
`
export default StyledStrategyMain
